import Input, { InputVariants } from '@anm/components/form/Input';
import { ChangeEvent, FC } from 'react';
import { branch, compose, renderComponent } from 'recompose';

import { FieldTypes } from '..';

import { LinkWrapper, TextAreaWrapper } from './Wrapper';

type FieldProps = Partial<FieldTypes> & {
  variant: InputVariants;
  multirows: boolean;
  defaultValue: string;
  autoFocus?: boolean;
  readOnly?: boolean;
  autoResize?: boolean;
  isFieldClickable?: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
};

const Link: FC<FieldProps> = ({ defaultValue: link }) => <LinkWrapper href={link}>{link}</LinkWrapper>;

const isTextArea = ({ multirows }: FieldProps) => multirows;
const isLink = ({ isFieldClickable, onChange }: FieldProps) => !!isFieldClickable && !onChange;

const Field = compose<{}, FieldProps>(
  branch(isTextArea, renderComponent(TextAreaWrapper)),
  branch(isLink, renderComponent(Link))
)(Input);

export default Field;
